'use strict';

// 引入统一登陆脚本
let Platform = require('../module/common_for_mall_tao_jd');
let platform = new Platform();
let userGrade = '';
function getUserInfo() {
    platform.login(function(){
        //登陆了
        if(userGrade) {
            rederUserInfo(userGrade);
        }else {
            platform.query({
                url: 'https://mvip.midea.cn/my/muc/get_user_info',
                data: {},
                type: 'POST'
            }).then((res) => {  // 请求数据成功回调
                if (res.errcode === 0) {
                    let resData = res.data;
                    userGrade = resData.grade;
                    rederUserInfo(userGrade);
                }else { 
                    alert('网络繁忙,请稍后重试');
                }
            }); 
        }
    },() => {
        alert('网络繁忙,请稍后重试');
    });
}


function rederUserInfo(grade) {
    let imgName = '';
    let btnClass = '';
    let drawHref= '';
    document.querySelector('.drawWrap_bg').style.display = 'block';
    switch(grade) {
        case 1:
            imgName = 'prompt_normal.png';
            btnClass = 'btn_normal';
            drawHref = 'https://m.midea.cn/act/help_center/index?mtag=30053.4.5&__fromuid=23448718';
            break;
        case 2:
            imgName = 'prompt_gold2.png';
            btnClass = 'btn_inormal';
            drawHref = 'https://m.midea.cn/promote/w/build/index/awTfmdaS0xWQ9OTc4?mtag=660002.2.4';
            break;
        case 3:
            imgName = 'prompt_diamond.png';
            btnClass = 'btn_inormal';
            drawHref = 'https://m.midea.cn/promote/w/build/index/awTfmdaS0xWQ9OTc4?mtag=660002.2.4';
            break;
    }
    let temp = `<img src="https://pic.mdcdn.cn/h5/img/act/20200120_portal/${ imgName }">
        <div class="close_btn"></div>
        <div class="confirm_btn ${ btnClass }" href="${ drawHref }"></div>
    `;
    $('#drawWrap').html(temp);
    //点击事件
    document.querySelector("#drawWrap .confirm_btn").onclick = function() {
        platform.go_link(drawHref);
    }
}  

function bindToDraw() {
    var btnToDraw = document.getElementById('toDraw');
    var oBgDraw = document.querySelector('.drawWrap_bg');
    var oWrapDraw = document.getElementById('drawWrap');
    btnToDraw.addEventListener('click', function (ev) {
        getUserInfo();
    }, false);
    oWrapDraw.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (/close_btn/.test(ev.target.className)) {
            oBgDraw.style.display = 'none';
        }
        if (/confirm_btn/.test(ev.target.className)) {
            // oBgDraw.style.display = 'block';
        }
    }, false);
}
(function(){
    bindToDraw();
})();


// WEBPACK FOOTER //
// ./pages/member_day_portal_20200120.js